import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-82486cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-setting dev-debug-trigger-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "dev-debug-trigger-text" }
const _hoisted_4 = { class: "dev-debug-main" }
const _hoisted_5 = {
  key: 0,
  class: "jp-debug-block"
}
const _hoisted_6 = { class: "jp-debug-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jp-debug-label" }, "日文专版（模拟）", -1))

import ProjectSubjectConfig
  from '@/views/dashboard/_components/central-control/_components/project-subject-config/project-subject-config.vue'
import {
  isJpOnlyBuildDebugOverride,
  setJpOnlyBuildDebugOverride
} from '@/common/const/build-locale'
import { toLoginPage } from '@/services/login.service'
import { isEditableShortcutTarget, isPlainShiftChord } from '@/utils/keyboard-shortcut'
import { onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'dev-debug',
  setup(__props) {

const { t } = useI18n()

/** 构建时日文包无此开关；与 IS_JP_ONLY_BUILD（含 localStorage 模拟）区分 */
const isJpBuildFromEnv = process.env.VUE_APP_JP_ONLY_BUILD === 'true'

const dialogVisible = ref(false)
const projectSubjectVisible = ref<boolean>(false)
const jpOnlyChecked = ref(isJpOnlyBuildDebugOverride())

function openDialog () {
  dialogVisible.value = true
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur()
  }
}

function handleClose () {
  dialogVisible.value = false
}

async function onJpOnlyChange (enabled: boolean) {
  const next = !!enabled
  if (next === isJpOnlyBuildDebugOverride()) {
    jpOnlyChecked.value = next
    return
  }

  setJpOnlyBuildDebugOverride(next)
  try {
    await toLoginPage(true)
  } catch {
    // 清理失败仍继续刷新，避免卡在半状态
  }
  window.location.reload()
}

function handleDevDebugKeydown (e: KeyboardEvent) {
  if (!isPlainShiftChord(e)) return
  if (isEditableShortcutTarget(e.target)) return
  if (e.key.toLowerCase() !== 'd') return

  e.preventDefault()
  openDialog()
}

onMounted(() => {
  window.addEventListener('keydown', handleDevDebugKeydown, true)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleDevDebugKeydown, true)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass(["dev-debug-float", { 'is-dialog-open': dialogVisible.value }])
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "dev-debug-trigger",
          "aria-label": _unref(t)('centralControl.devDebug'),
          onClick: openDialog
        }, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('centralControl.devDebug')), 1)
        ], 8, _hoisted_1)
      ], 2)
    ])),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "custom-class": "dev-debug-dialog",
      title: "开发与调试(仅在开发、测试环境展示)",
      "model-value": dialogVisible.value,
      "show-close": "",
      width: 600,
      onClose: handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (projectSubjectVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换项目主体")
            ]),
            _: 1
          }),
          (!isJpBuildFromEnv)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_el_switch, {
                    "model-value": jpOnlyChecked.value,
                    onChange: onJpOnlyChange
                  }, null, 8, ["model-value"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(ProjectSubjectConfig, {
      modelValue: projectSubjectVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((projectSubjectVisible).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})